import { FirebaseActionTypes, FirebaseActions, FirebaseTypes } from '@web_opxp/features';
import { EExerciseCategory } from '../base/types';
import { EExtraMode, IFullFeedbackResult } from './types';

export const startSessionAction: (sessionId: number) => FirebaseActionTypes.IAnalyticsEventAction = (sessionId) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'g_session_started',
    parameters: [
      {
        key: 'Session_ID',
        value: sessionId,
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const completeSessionAction: (sessionId: number) => FirebaseActionTypes.IAnalyticsEventAction = (sessionId) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'g_session_completed',
    parameters: [
      {
        key: 'Session_ID',
        value: sessionId,
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const workoutFeedbackAction: (feedback: IFullFeedbackResult) => FirebaseActionTypes.IAnalyticsEventAction = ({
  exerciseId,
  startDifficulty,
  endDifficulty,
  goodRuns,
  badRuns,
  completionCount,
  feedback,
  negativeFollowup,
  comprehensionFollowup,
}) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'g_workout_feedback_thumbs',
    parameters: [
      {
        key: 'exerciseId',
        value: exerciseId,
      },
      {
        key: 'startDifficulty',
        value: startDifficulty,
      },
      {
        key: 'endDifficulty',
        value: endDifficulty,
      },
      {
        key: 'goodRuns',
        value: goodRuns,
      },
      {
        key: 'badRuns',
        value: badRuns,
      },
      {
        key: 'completionCount',
        value: completionCount,
      },
      {
        key: 'feedback',
        value: `${feedback}`,
      },
      {
        key: 'negativeFollowup',
        value: `${negativeFollowup}`,
      },
      {
        key: 'comprehensionFollowup',
        value: `${comprehensionFollowup}`,
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const ledFollowupFeedbackAction: (
  workoutId: number,
  feedbackAnswer: boolean,
  prevCategoryId: EExerciseCategory,
  currentCategoryId: EExerciseCategory
) => FirebaseActionTypes.IAnalyticsEventAction = (workoutId, feedbackAnswer, prevCategoryId, currentCategoryId) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'e_followup_feedback',
    parameters: [
      {
        key: 'workoutId',
        value: workoutId,
      },
      {
        key: 'feedback_change',
        value: feedbackAnswer ? 1 : 0,
      },
      {
        key: 'previous_category',
        value: prevCategoryId,
      },
      {
        key: 'current_category',
        value: currentCategoryId,
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const workoutDiffChangeAction: (
  workoutId: number,
  changeDifficulty: boolean,
  change: -1 | 1
) => FirebaseActionTypes.IAnalyticsEventAction = (workoutId, changeDifficulty, change) => {
  const firebasePayload: FirebaseTypes.IEventActionPayload = {
    eventName: 'e_workout_diff_change',
    parameters: [
      {
        key: 'workoutId',
        value: workoutId,
      },
      {
        key: 'user_choice',
        value: changeDifficulty ? 1 : 0,
      },
      {
        key: 'change',
        value: change,
      },
    ],
  };
  return FirebaseActions.analyticsEventAction(firebasePayload);
};

export const gameModeChangedEvent = () => FirebaseActions.analyticsEventAction({ eventName: 'mode_changed' });

export const gameModeSelectionViewOpened = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'mode_selection_view' });

export const gameModeSelected = (mode: EExtraMode) =>
  FirebaseActions.analyticsEventAction({ eventName: 'mode_selected', parameters: [{ key: 'Mode', value: mode }] });

export const backFromNotImplementedScreen = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'mode_unavailable_back' });

export const postSessionBoosterOpened = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'booster_post_session' });

export const postFirstSessionOpened = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'e_session_complete_view' });

export const challengeCompleteButtonClicked = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'challenge_complete_button' });
